import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { fmtNum, ORDER_STATUSES } from "@/lib/constants";

export default function Reports() {
  const [byCompany, setByCompany] = useState([]);
  const [byProduct, setByProduct] = useState([]);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get("/admin/reports/by-company").then(({ data }) => setByCompany(data));
    api.get("/admin/reports/by-product").then(({ data }) => setByProduct(data));
    api.get("/admin/reports/orders-summary").then(({ data }) => setSummary(data));
  }, []);

  const downloadCsv = async () => {
    const token = localStorage.getItem("evser_token");
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/reports/export-orders.csv`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "siparisler.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6" data-testid="admin-reports-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <span className="label-tag">Analiz</span>
          <h1 className="font-serif text-4xl mt-2">Raporlar</h1>
        </div>
        <button onClick={downloadCsv} className="btn-luxe-outline text-xs" data-testid="reports-csv-btn">CSV Dışa Aktar</button>
      </div>

      <Tabs defaultValue="company">
        <TabsList>
          <TabsTrigger value="company" data-testid="report-tab-company">Firma Bazlı</TabsTrigger>
          <TabsTrigger value="product" data-testid="report-tab-product">Ürün Bazlı</TabsTrigger>
          <TabsTrigger value="status" data-testid="report-tab-status">Durum Özeti</TabsTrigger>
        </TabsList>

        <TabsContent value="company">
          <div className="bg-white border border-[#eae5dc] overflow-x-auto mt-4">
            <table className="w-full text-sm min-w-[600px]">
              <thead><tr className="bg-[#f7f5f0] text-xs uppercase tracking-wider text-[#6b655c]">
                <th className="text-left py-3 px-4">Firma</th>
                <th className="text-right py-3 px-4">Sipariş</th>
                <th className="text-right py-3 px-4">CM</th>
                <th className="text-right py-3 px-4">m²</th>
              </tr></thead>
              <tbody>
                {byCompany.length === 0 && <tr><td colSpan={4} className="py-12 text-center text-[#6b655c]">Veri yok</td></tr>}
                {byCompany.map((r) => (
                  <tr key={r._id} className="border-t border-[#f0ebe2]">
                    <td className="py-3 px-4 font-medium">{r.company_name}</td>
                    <td className="py-3 px-4 text-right">{r.orders}</td>
                    <td className="py-3 px-4 text-right">{fmtNum((r.meters || 0) * 100)}</td>
                    <td className="py-3 px-4 text-right font-medium">{fmtNum(r.sqm)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>

        <TabsContent value="product">
          <div className="bg-white border border-[#eae5dc] overflow-x-auto mt-4">
            <table className="w-full text-sm min-w-[700px]">
              <thead><tr className="bg-[#f7f5f0] text-xs uppercase tracking-wider text-[#6b655c]">
                <th className="text-left py-3 px-4">Ürün</th>
                <th className="text-right py-3 px-4">Adet</th>
                <th className="text-right py-3 px-4">CM</th>
                <th className="text-right py-3 px-4">m²</th>
              </tr></thead>
              <tbody>
                {byProduct.length === 0 && <tr><td colSpan={4} className="py-12 text-center text-[#6b655c]">Veri yok</td></tr>}
                {byProduct.map((r) => (
                  <tr key={r._id} className="border-t border-[#f0ebe2]">
                    <td className="py-3 px-4 font-medium">{r.name}</td>
                    <td className="py-3 px-4 text-right">{fmtNum(r.qty)}</td>
                    <td className="py-3 px-4 text-right">{fmtNum((r.meters || 0) * 100)}</td>
                    <td className="py-3 px-4 text-right font-medium">{fmtNum(r.sqm)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>

        <TabsContent value="status">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            {summary && ORDER_STATUSES.map((s) => (
              <div key={s} className="bg-white border border-[#eae5dc] p-6">
                <div className="text-xs uppercase tracking-wider text-[#c8a97e]">{s}</div>
                <div className="font-serif text-3xl mt-2">{summary[s].count}</div>
                <div className="text-xs text-[#6b655c] mt-1">{fmtNum(summary[s].sqm)} m² · {fmtNum((summary[s].meters || 0) * 100)} cm</div>
              </div>
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
